export default (key: string): string => {
  const cookies: Record<string, string> = {};
  document.cookie
    .split('; ')
    .forEach(item => Object.assign(cookies, { [item.split('=')[0]]: item.split('=')[1] }));
  return cookies[key] ?? '';
};
